



























import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

import container from '@/container';
import {
    CONTRACTS,
    WindowsServiceContract,
    StringsServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';

import Devtools from '@/core/components/Devtools.vue';
import Contexts from '@/core/components/Contexts.vue';
import { ContextsState } from '@/store';
import Products from '@/core/components/Products.vue';
import Indicators from '@/core/components/Indicators.vue';
import Network from '@/core/components/Network.vue';
import Tiles from '@/core/components/tiles/Tiles.vue';
import Splitter from '@/core/components/tiles/Splitter.vue';
import { Box } from '@/core/components/tiles/types';
import { createMaxBox } from '@/core/components/tiles/utils';

import { UserState } from '@/store';
import { debounce } from 'lodash';
import config from '@/config';

@Component({
    components: {
        Devtools,
        Contexts,
        Products,
        Indicators,
        Network,
        Tiles,
        Splitter,
    },
})
export default class Home extends Vue {
    public splitterRatio: number = 0;
    public splitterMinRatio: number = .1;
    public splitterDirection: string = 'h';
    public splitterBoundingBox: Box = createMaxBox();

    public forceUpdateForCultureChange: string | undefined = this.currentCulture;

    @Inject(CONTRACTS.WindowsService) private windowsService?: WindowsServiceContract;
    private firstMounted: boolean = true;
    private directLinkContext: string | undefined;

    private resizeDebounced = debounce(
        this.onDebouncedEvent.bind(this),
        config.events.chartResizeDelay
    );

    public get devmode(): boolean {
        return this.$store.state.devmode;
    }

    public get currentContextId(): string | undefined {
        return ContextsState.currentContextId;
    }

    public get contextsList() {
        return ContextsState.list;
    }

    public get currentCulture(): string | undefined {
        return UserState.current!.culture;
    }

    public mounted(): void {
        this.splitterRatio = this.controlsWidth / this.interfaceWidth;
    }

    @Watch('currentContextId')
    public onContextChange() {
        const routeParamsContext = this.$route.params.context;

        if (this.directLinkContext !== undefined && this.directLinkContext !== String(this.currentContextId)) {
            const routeContext = this.contextsList.filter(context => {
                return String(context.id) === this.directLinkContext;
            });

            if (routeContext.length !== 0) {
                ContextsState.changeContext(routeContext[0]);
            } else {
                this.windowsService!.showDialog(`Such context doesn't exist!`);
                this.$router.push({ path: `/contexts/${this.currentContextId}` });
            }
        } else if (routeParamsContext === undefined || routeParamsContext !== String(this.currentContextId)) {
                this.$router.push({ path: `/contexts/${this.currentContextId}` });
        }
        this.directLinkContext = undefined;
    }

    @Watch('currentCulture')
    public async onCultureChange() {
        const strings = container.get<StringsServiceContract>(CONTRACTS.StringsService);
        await strings.reloadAsync();

        this.forceUpdateForCultureChange = this.currentCulture;
    }

    @Watch('$route', { immediate: true, deep: true })
    public onUrlChange(val: any) {
        if (this.firstMounted && val.params.context !== undefined) {
            this.directLinkContext = val.params.context;
        }
        this.firstMounted = false;
    }

    public calculateControlsStyle(): object {
        return {
            width: this.splitterRatio ? (this.interfaceWidth * this.splitterRatio) + 'px' : null
        };
    }

    private get interfaceWidth(): number {
        return (this.$refs.interface as Element).getBoundingClientRect().width;
    }

    private get controlsWidth(): number {
        return (this.$refs.controls as Element).getBoundingClientRect().width;
    }

    public onResize(ratio: number) {
        this.splitterRatio = ratio;
        this.resizeDebounced(this);
    }

    private onDebouncedEvent(e: any) {
        const resizeEvent = new Event('homeResize');
        window.dispatchEvent(resizeEvent);
    }
}
